import { render, staticRenderFns } from "./template_point.vue?vue&type=template&id=5027637a&"
import script from "./template_point.vue?vue&type=script&lang=js&"
export * from "./template_point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports